import { apiAxios } from '../utils/axios';

export const GetSubscription = async (token: string) => {
  const config = {
    method: 'GET',
    url: '/get_ipchecker_subscription',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return await apiAxios.get(config.url, {
    headers: config.headers,
  });
};
